import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export const DEFAULT_PAGE_TITLE = 'Conectio - Where talent meets growth';

/**
 * Browser tab titles from the routes: each route sets `title` to a translation key (e.g. 'pageTitles.signup'),
 * shown in the active language and updated when the language changes. Routes without a title get the default.
 */
@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private currentKey: string | undefined;

  constructor(private title: Title, private translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe(() => this.applyTitle());
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.currentKey = this.buildTitle(snapshot);
    this.applyTitle();
  }

  private applyTitle(): void {
    const key = this.currentKey;
    if (!key) {
      this.title.setTitle(DEFAULT_PAGE_TITLE);
      return;
    }
    // get() waits for the translations to load; until then the pipe would return the key itself
    this.translate.get(key).subscribe((text: string) => {
      if (key === this.currentKey) {
        this.title.setTitle(text && text !== key ? text : DEFAULT_PAGE_TITLE);
      }
    });
  }
}
